<template>
  <div>
    <b-modal
            v-if="!userData"
            id="loginModal"
            ref="loginModal"
            size="md"
            modal-class="main-modal"
            ok-title="Закрыть"
            ok-only
            ok-variant="success modal-ok"
            header-class="text-white border-0"
            header-close-variant="orange"
            :title="reason"
            title-class="text-center underlined-muted-title"
            footer-class="border-0"
            hide-footer
            body-class="pt-0"
            centered
    >
      <div class="row mx-0 col-12 mx-auto px-0 px-md-3">
        <div class="col-12 mx-auto py-3 px-0">
          <b-form
                  class="login-form py-t pb-0" autocomplete="off"
                  @submit.prevent="Login"
          >
            <div class="col-12  mx-auto mb-1">
              <div class="col-12">
                <div class="input-group mb-4">
                  <div class="col-12">
                    <input
                            v-model="payload.login"
                            class="form-control auth-input"
                            required
                            type="text"
                            placeholder="Логин аккаунта"
                    >
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="input-group mb-4">
                  <div class="col-12">
                    <input
                            v-model="payload.password"
                            type="password"
                            class="form-control auth-input"
                            required
                            placeholder="Пароль"
                    >
                  </div>
                </div>
              </div>

              <div class="col-12 mb-3">
                <alert :message="response" class="px-3" />
                <div class="clearfix" />
              </div>

              <div class="col-12">
                <div class="col-12 mx-auto">
                  <div class="green-btn-bg">
                    <button
                            name="isSubmitting"
                            class="btn auth-btn btn-green w-100 main-btn" :disabled="isSubmitting"
                            @click.prevent="Login"
                    >
                      Войти!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </b-form>

          <div class="col-12  mx-auto justify-content-between row px-0 px-lg-3">
            <div class="col-12 mt-3 px-0 px-lg-3">
              <div class="mx-auto col-12 text-center text-lg-right px-0 px-lg-3">
                <router-link
                        class="text-muted w-50 float-left"
                        :to="{ path: '/registration' }"
                >
                  <small v-if="isMobile">Регистация</small>
                  <small v-else>Регистрируйтесь бесплатно!</small>
                </router-link>
                <small class="text-muted cursor-pointer w-50 d-inline-block" @click="openRecoverModal">
                  Забыли пароль?
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <ForgotPassword></ForgotPassword>
  </div>
</template>

<script>
import Alert from '@/components/Alert'
import ForgotPassword from '@/components/user/actions/ForgotPassword'

export default {
  name: 'LoginPopUp',
  components: {
    Alert,
    ForgotPassword
  },
  data () {
    return {
      response: null,
      isSubmitting: false,
      reason: '',
      payload: {
        login: '',
        password: ''
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    },
    isMobile () {
      return this.$_config.environment.mobile
    }
  },
  methods: {
    openRecoverModal () {
      return this.$root.$emit('bv::show::modal', 'recoverAccountModal')
    },
    Login () {
      this.response = { status: 'loading' }
      this.isSubmitting = true
      this.axios.post(
        this.$_config.baseUrl + '/Api/Login', {
          authorize: this.payload
        }
      ).then((userData) => {
        const data = userData.data
        this.isSubmitting = false
        this.response = data
        if (data.status === 'ok') {
          this.$store.dispatch('fetchApiData')
          this.$store.dispatch('fetchUserData')
          this.response = { status: 'ok', msg: 'Добро пожаловать' }
          this.$store.dispatch('fetchMessages')
          this.$store.dispatch('fetchWheelStatistic')
        }
      }).catch((err) => {
        if (err) {
          this.isSubmitting = false
          this.response = { status: 'error', msg: err.response.data.errors }
        }
      })
    }
  },
  mounted () {
    if (this.userData) {
      this.$router.push({ name: 'home' })
    }
    const _this = this
    this.$root.$on('reasonToLogin', function (value) {
      _this.reason = value
    })
  },
  watch: {
    userData (newVal, oldVal) {
      if (newVal && oldVal) {
        if (this.userData) {
          this.$router.push({ path: '/' })
        }
      }
    },
    $route: function () {
      this.response = null
    },
    reasonToLogin: {
      deep: true
    }
  }
}
</script>

<style>
    .underlined-muted-title{
        font-size: 16px;
        color:#ffffff;
        border-bottom: 1px solid #ffffff;
        margin: 0 auto;
        text-shadow:0 0 1px #aba9a9;
        user-select: none;
    }

    #loginModal .modal-header .close{
        margin: 0 !important;
        padding: 0 !important;
        position: absolute;
        right: 10px;
        top: 10px;
    }

    #loginModal .modal-header .modal-title{
      max-width: 90%;
    }
</style>
